import apple from "../../../assets/apple-logo.png";
import google from "../../../assets/google-play.png";
import hero from "../../../assets/users-hero.png";
import mobile from "../../../assets/agent-tabs.png";

const HeroSection = () => {
  return (
    <div className="max-lg:px-6 lg:ml-16 py-14 lg:pt-10 lg:pb-20">
      <div className="lg:text-center">
        <div className="">
          <div>
            <h1 className="lg:max-w-[80%] mx-auto text-3xl leading-[42.3px] lg:text-6xl lg:leading-[81px] font-semibold text-primary">
              Effortlessly deliver your products and items with ZAP's
              hassle-free logistics platform
            </h1>
            <div className="max-lg:hidden my-10">
              <img src={hero} alt="" className="max-w-[70%] mx-auto" />
            </div>
            <div className="max-lg:hidden">
              <h1 className="head-text">Download app</h1>
            </div>
            <div className="flex items-center lg:justify-center space-x-5 mt-7">
              <div className="download-btn">
                <div className="w-5 sm:w-7">
                  <img className="w-full" alt="" src={apple} />
                </div>
                <div>
                  <span className="text-xs text-paragraph">
                    Download on the
                  </span>
                  <h1 className="max-sm:text-xs font-medium text-primaryBlack -mt-1">
                    App Store
                  </h1>
                </div>
              </div>
              <div className="download-btn">
                <div className="w-5 sm:w-7">
                  <img className="w-full" alt="" src={google} />
                </div>
                <div>
                  <span className="text-xs text-paragraph">Get it on</span>
                  <h1 className="max-sm:text-xs font-medium text-primaryBlack -mt-1">
                    Google Play
                  </h1>
                </div>
              </div>
            </div>
            <div className="lg:hidden my-10">
              <img src={mobile} alt="" className="max-w-[60%] mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
